import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetWarrantyInfoListQueryVariables = Types.Exact<{
  applicationIds: Array<Types.Scalars['Long']['input']> | Types.Scalars['Long']['input'];
}>;


export type GetWarrantyInfoListQuery = { __typename?: 'Query', warrantyInfoList: Array<{ __typename?: 'WarrantyInfoResponse', applicationId: any, applicationNo: string, applicationDate: string, accountNo: string, status: string, updateDate: string, itemQty: number, otherProductList: Array<{ __typename?: 'ProductGroup', categoryName: string, subCategoryName: string, reasonText: string, reasonMemo: string, productId: string, productName: string }>, talkalongCardProductList: Array<{ __typename?: 'ProductGroup', categoryName: string, subCategoryName: string, reasonText: string, reasonMemo: string, productId: string, productName: string }> }> };


export const GetWarrantyInfoListDocument = gql`
    query GetWarrantyInfoList($applicationIds: [Long!]!) {
  warrantyInfoList(parameter: {applicationIds: $applicationIds}) {
    applicationId
    applicationNo
    applicationDate
    accountNo
    status
    updateDate
    itemQty
    otherProductList {
      categoryName
      subCategoryName
      reasonText
      reasonMemo
      productId
      productName
    }
    talkalongCardProductList {
      categoryName
      subCategoryName
      reasonText
      reasonMemo
      productId
      productName
    }
  }
}
    `;

/**
 * __useGetWarrantyInfoListQuery__
 *
 * To run a query within a React component, call `useGetWarrantyInfoListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarrantyInfoListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarrantyInfoListQuery({
 *   variables: {
 *      applicationIds: // value for 'applicationIds'
 *   },
 * });
 */
export function useGetWarrantyInfoListQuery(baseOptions: Apollo.QueryHookOptions<GetWarrantyInfoListQuery, GetWarrantyInfoListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarrantyInfoListQuery, GetWarrantyInfoListQueryVariables>(GetWarrantyInfoListDocument, options);
      }
export function useGetWarrantyInfoListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarrantyInfoListQuery, GetWarrantyInfoListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarrantyInfoListQuery, GetWarrantyInfoListQueryVariables>(GetWarrantyInfoListDocument, options);
        }
export type GetWarrantyInfoListQueryHookResult = ReturnType<typeof useGetWarrantyInfoListQuery>;
export type GetWarrantyInfoListLazyQueryHookResult = ReturnType<typeof useGetWarrantyInfoListLazyQuery>;
export type GetWarrantyInfoListQueryResult = Apollo.QueryResult<GetWarrantyInfoListQuery, GetWarrantyInfoListQueryVariables>;